import { defineComponent as _defineComponent } from 'vue'
import { ref, shallowRef } from 'vue'
import { ILeftTab } from '@/layout/type'
import LeftTabsLayout from '@/layout/LeftTabsLayout.vue'
import Offline from './offline/index.vue'
// import Realtime from './realtime/index.vue'
import AsrList from './asrList/index.vue'


import { Route } from 'vue-router'
import { AsrRtModule } from '@/store/modules/asr-rt'

const __default__ = {
  beforeRouteLeave(to: Route, from: Route, next: Function) {
    console.log('beforeRouteLeave')
    const needAlert = AsrRtModule.needAlert
    if(needAlert) {
      AsrRtModule.ToggleAlertDialogVisible(true)
      AsrRtModule.PushCancelCb(() => {
        next(false)
      })
      AsrRtModule.PushCancelSaveCb(() => {
        next(true)
        AsrRtModule.ToggleNeedAlert(false)
      })
      AsrRtModule.PushSaveCb(() => {
        next(true)
      })
    } else {
      next()
    }
  }
}

function beforeSwitchTab(): Promise<void> {
  const needAlert = AsrRtModule.needAlert
  if(needAlert) {
    return new Promise((resolve, reject) => {
      AsrRtModule.ToggleAlertDialogVisible(true)
      AsrRtModule.PushCancelCb(() => {
        console.log('取消回调')
        reject()
      })
      AsrRtModule.PushCancelSaveCb(() => {
        console.log('取消保存回调')
        resolve()
        AsrRtModule.ToggleNeedAlert(false)
      })
      AsrRtModule.PushSaveCb(() => {
        console.log('保存回调')
        resolve()
        AsrRtModule.ToggleNeedAlert(false)
      })
    })
  }
  return Promise.resolve()
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'index',
  setup(__props) {

const activeIndex= ref('offline')
const tabs: ILeftTab[] = [
  // {
  //   name: 'realtime',
  //   icon: 'icon_asr_rt2',
  //   label: '实时识别',
  //   hiddenBackground:true
  // },
  {
    name: 'offline',
    icon: 'icon_asr_offline2',
    label: '离线识别',
    hiddenBackground:true
  },
  {
    name: 'list',
    icon: 'icon_result_list',
    label: '结果列表',
    hiddenBackground:true
  },
]
function handleChangeTab() {
  AsrRtModule.ToggleNeedAlert(false)
}
const leftTabsRef = shallowRef<InstanceType<typeof LeftTabsLayout>>()
function handleSetTab(tabKey: string) {
  leftTabsRef.value?.setTab(tabKey)
}


return { __sfc: true,beforeSwitchTab, activeIndex, tabs, handleChangeTab, leftTabsRef, handleSetTab, LeftTabsLayout, Offline, AsrList }
}

})